import { Flex, Input, Message } from 'components';
import * as bi from 'react-bootstrap-icons';
import { MessagePoint } from '..';
import { ModalCalendar, SpoilerCard } from 'shared/components';
import { useEffect, useState } from 'react';
import { isPassportIssueDateValid, passportClearFormatting, passportFormat, passportIsValid } from './helpers';
import { dateFormat } from 'common/helpers';
import { IPassportInput } from '../../types';
import { IClientPassengerFullPassport } from '@bustickus/models-client';

interface IProps {
  open: boolean;
  onOpen: () => void;
  onChange: (passport: IPassportInput | null) => void;
  initial?: IClientPassengerFullPassport | null;
}

function PassportCard(props: IProps) {
  const [passportNumber, setPassportNumber] = useState<string>(passportFormat(props.initial?.number ?? ''));
  const [passportIssueDate, setPassportIssueDate] = useState<Date | null>(
    props.initial != null ? new Date(props.initial.issueDate) : null
  );
  const [passportIssueDateModal, setPassportIssueDateModal] = useState<boolean>(false);
  const [passportNumberTouched, setPassportNumberTouched] = useState<boolean>(false);
  const [passportIssueDateTouched, setPassportIssueDateTouched] = useState<boolean>(false);

  useEffect(() => {
    handleDataChange(passportNumber, passportIssueDate);
  }, []);

  const handlePassportNumberChange = (value: string) => {
    if (!passportNumberTouched) {
      setPassportNumberTouched(true);
    }

    setPassportNumber(passportFormat(value));
    handleDataChange(value, passportIssueDate);
  };

  const handlePassportIssueDateChange = (issueDate: Date) => {
    if (!passportIssueDateTouched) {
      setPassportIssueDateTouched(true);
    }

    if (passportIssueDateModal) {
      setPassportIssueDateModal(false);
    }

    setPassportIssueDate(issueDate);
    handleDataChange(passportNumber, issueDate);
  };

  const handleDataChange = (num: string, issueDate: Date | null) => {
    if (issueDate != null && passportIsValid(num) && isPassportIssueDateValid(issueDate)) {
      props.onChange({ number: passportClearFormatting(num), issueDate: issueDate });
    } else {
      props.onChange(null);
    }
  };

  const isNumberError = !passportIsValid(passportNumber);
  const isIssueDateError = !isPassportIssueDateValid(passportIssueDate);
  const isInputError = isNumberError || isIssueDateError;

  return (
    <SpoilerCard
      open={props.open}
      onOpenClick={props.onOpen}
      title='Паспорт РФ'
    >
      {passportIssueDateModal && (
        <ModalCalendar
          onClose={() => setPassportIssueDateModal(false)}
          onSelect={handlePassportIssueDateChange}
          date={passportIssueDate ?? new Date(2020, 0, 1)}
        />
      )}

      <Flex
        direction='column'
        gap={10}
      >
        <Flex
          direction='column'
          gap={5}
        >
          <Input
            type='text'
            label='Серия и номер'
            placeholder='7612 123456'
            value={passportNumber}
            onChange={handlePassportNumberChange}
            icon={<bi.Passport />}
            error={isNumberError && passportNumberTouched}
          />
          <Input
            type='text'
            label='Дата выдачи'
            placeholder='Нажмите для выбора...'
            value={passportIssueDate != null ? dateFormat(passportIssueDate, 'DD MMMM YYYY').datetime : ''}
            onClick={() => setPassportIssueDateModal(true)}
            icon={<bi.Calendar />}
            error={isIssueDateError && passportIssueDateTouched}
          />
        </Flex>

        {isInputError && (
          <Message type='error'>
            <Flex
              direction='column'
              gap={5}
            >
              {isNumberError && <MessagePoint type='error'>Номер паспорта заполнен неверено!</MessagePoint>}
              {isIssueDateError && <MessagePoint type='error'>Дата выдачи паспорта заполнена неверно!</MessagePoint>}
            </Flex>
          </Message>
        )}
        {!isInputError && (
          <Message type='success'>
            <MessagePoint type='success'>
              <b>Отлично!</b> Данные паспорта выглядят корректно.
            </MessagePoint>
          </Message>
        )}
      </Flex>
    </SpoilerCard>
  );
}

export default PassportCard;
